import React from 'react';
import Form from 'react-bootstrap/Form';
// import Select from 'react-select';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import WrapperModal from '../shared/Modals/WrapperModal/WrapperModal';
import { TitleAndCloseHeader } from '../shared/Modals/Headers/HeaderFunctions';
import { CloseAndActionFooter } from '../shared/Modals/Footers/FooterFunctions';

const SendLaterModal = (props) => (
  <WrapperModal
    show={props.data.showSendLaterModal}
    onClose={props.handlers.handleShowSendLaterModal}
    header={{
      exist: true,
      component: (
        <TitleAndCloseHeader
          data={{
            title: 'Set Schedule',
            handleCloseModal: props.handlers.handleShowSendLaterModal,
          }}
        />
      ),
    }}
    footer={{
      exist: true,
      component: (
        <CloseAndActionFooter
          data={{
            actionTitle: 'Confirm Schedule',
            handleCloseModal: props.handlers.handleShowSendLaterModal,
            handleActionButton: props.handlers.handleSendLater,
            isLoading: props.data.sendLaterLoading,
          }}
        />
      ),
    }}
    centered={true}
    styles={'SendLaterModal'}
  >
    <div className="row">
      <div className="col-12">
        <Form onSubmit={props.handlers.handleSendLater}>
          <div className="row">
            <div className="col-12">
              <Form.Group controlId="scheduleName">
                <Form.Label>Schedule Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Schedule Name"
                  className={props.data.scheduleNameError ? 'is-invalid' : ''}
                  onChange={(e) => props.handlers.handleUserInput(e)}
                />
                {props.data.scheduleNameError && (
                  <Form.Text>Schedule name is required</Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group controlId="date">
                <Form.Label>Select Prefered Date and Time</Form.Label>
                <DateRangePicker
                  initialSettings={{
                    parentEl: '.SendLaterModal',
                    singleDatePicker: true,
                    showDropdowns: true,
                    timePicker: true,
                    locale: {
                      cancelLabel: 'Clear',
                      format: 'DD/MM/YYYY hh:mm A',
                    },
                    autoUpdateInput: false,
                  }}
                  onEvent={(event, picker) =>
                    props.handlers.handleDatePicker(event, picker)
                  }
                >
                  <Form.Control
                    type="text"
                    className={
                      'form-control datetime ' +
                      (props.data.preferedDateTimeError ? 'is-invalid' : '')
                    }
                    placeholder="Select Date"
                    aria-invalid="false"
                    autoComplete="off"
                  />
                </DateRangePicker>
                {props.data.preferedDateTimeError && (
                  <Form.Text>Prefered date and time is required</Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="file-format">
                <Form.Label>IMPORTANT NOTES</Form.Label>
                <Form.Text as="span">
                  This scheduler will automatically send your Message in your
                  prefered time and date.
                  <br />
                  <br />
                  To STOP scheduled messages, select the stop scheduler icon on
                  the table action column.
                  <br />
                  <br />
                  Only scheduled messages with the status "WAITING" can be
                  updated to STOPPED. <br />
                  <br />
                  Scheduled messages in the queue will be marked as "FAILED"
                  when the account doesn't have enough balance to send the
                  messages.
                </Form.Text>
              </Form.Group>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </WrapperModal>
);

export default SendLaterModal;
